import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'happy-details-group',
  templateUrl: './happy-details-group.component.html',
  styleUrls: ['./happy-details-group.component.css', '../styles.css']
})
export class HappyDetailsGroupComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-details-group/happy-details-group.component.ts